<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        
        @click="openAdd()"
        >添加</el-button
      >
      <el-button type="danger" size="mini"  @click="open"
        >删除</el-button
      >
      <el-button
        type="success"
        size="mini"
        
        @click="getList"
        >刷新</el-button
      >
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        
        style="margin-left: 10px"
        @click="select()"
        >筛选</el-button
      >
    </div>
    <div class="head_search">
      <div class="item_warp">
        <label style="margin: 0 10px;">编号</label>
        <el-input
          v-model="sn"
          placeholder="请输入编号"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px;">语种</label>
        <el-input
          v-model="lang"
          placeholder="请输入语种"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
    </div>
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="tableData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      height="calc(100vh - 240px )"
      style="width: 1071px"
      size="mini"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50"/>
      <el-table-column prop="address" label="操作" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.isSystem">-</div>
          <el-button
            v-else
            type="primary"
            class="edit-button"
            size="mini"
            
            @click="edit(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
      <el-table-column prop="sn" label="编号" width="150" />
      <el-table-column prop="lang" label="语种" width="100" />
      <el-table-column prop="withdrawSum" label="图片" width="200">
        <template slot-scope="scoped">
          <el-image
            style="width: 80px;"
            :src="scoped.row.image"
            fit="fill"
            :preview-src-list="new Array(scoped.row.image)"
            @click.stop="handleClickItem"
          />
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" width="200" />
      <el-table-column prop="orders" label="排序" width="100" />
      <el-table-column prop="createDate" label="创建时间" width="170" />
      
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getList"
    />

    <!-- 添加弹窗 -->
    <el-dialog
      title="添加"
      :visible.sync="dialogVisible"
      width="1000px"
      :close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="active" label-width="150px" size="mini">
        <el-form-item label="排序">
          <el-input v-model="active.orders" placeholder="请输入序号" />
        </el-form-item>
        <el-form-item label="图片">
          <UploadImage ref="image" @upLoadImage='upLoadImage'></UploadImage>
        </el-form-item>
        <div style="font-weight: 900;width:138px;text-align: end;margin-bottom: 10px;">标题</div>
        <el-form-item label="英文" style="margin-bottom: 8px;">
          <el-input v-model="active.titleEn" placeholder="请输入标题（英文）" />
        </el-form-item>
        <el-form-item label="西班牙语" style="margin-bottom: 8px;">
          <el-input v-model="active.titleEs" placeholder="请输入标题（西班牙语）" />
        </el-form-item>
        <el-form-item label="法语" style="margin-bottom: 8px;">
          <el-input v-model="active.titleFr" placeholder="请输入标题（法语）" />
        </el-form-item>
        <el-form-item label="德语" style="margin-bottom: 8px;">
          <el-input v-model="active.titleDe" placeholder="请输入标题（德语）" />
        </el-form-item>
        <el-form-item label="葡萄牙语" style="margin-bottom: 8px;">
          <el-input v-model="active.titlePt" placeholder="请输入标题（葡萄牙语）" />
        </el-form-item>
        <el-form-item label="土耳其语" style="margin-bottom: 8px;">
          <el-input v-model="active.titleTr" placeholder="请输入标题（土耳其语）" />
        </el-form-item>
        <el-form-item label="希腊语" style="margin-bottom: 8px;">
          <el-input v-model="active.titleGr" placeholder="请输入标题（希腊语）" />
        </el-form-item>
        <el-form-item label="阿拉伯语" style="margin-bottom: 8px;">
          <el-input v-model="active.titleEg" placeholder="请输入标题（阿拉伯语）" />
        </el-form-item>
        <el-form-item label="意大利语" style="margin-bottom: 8px;">
          <el-input v-model="active.titleIt" placeholder="请输入标题（意大利语）" />
        </el-form-item>
        <el-form-item label="波斯语" style="margin-bottom: 8px;">
          <el-input v-model="active.titleIr" placeholder="请输入标题（波斯语）" />
        </el-form-item>
        <el-form-item label="荷兰语" style="margin-bottom: 8px;">
          <el-input v-model="active.titleNl" placeholder="请输入标题（荷兰语）" />
        </el-form-item>
        <el-form-item label="印地语" style="margin-bottom: 8px;">
          <el-input v-model="active.titleIn" placeholder="请输入标题（印地语）" />
        </el-form-item>
        <el-form-item label="乌兹别克语" style="margin-bottom: 8px;">
          <el-input v-model="active.titleUz" placeholder="请输入标题（乌兹别克语）" />
        </el-form-item>
        <el-form-item label="越南语" style="margin-bottom: 8px;">
          <el-input v-model="active.titleVn" placeholder="请输入标题（越南语）" />
        </el-form-item>
        <el-form-item label="印尼语" style="margin-bottom: 8px;">
          <el-input v-model="active.titleId" placeholder="请输入标题（印尼语）" />
        </el-form-item>
        <el-form-item label="乌尔都语" style="margin-bottom: 8px;">
          <el-input v-model="active.titlePk" placeholder="请输入标题（乌尔都语）" />
        </el-form-item>
        <el-form-item label="韩语" style="margin-bottom: 8px;">
          <el-input v-model="active.titleKr" placeholder="请输入标题（韩语）" />
        </el-form-item>
         <el-form-item label="俄语" style="margin-bottom: 8px;">
          <el-input v-model="active.titleRu" placeholder="请输入标题（俄语）" />
        </el-form-item>
        <el-form-item label="泰语" style="margin-bottom: 8px;">
          <el-input v-model="active.titleTh" placeholder="请输入标题（泰语）" />
        </el-form-item>
        <el-form-item label="波兰语" style="margin-bottom: 8px;">
          <el-input v-model="active.titlePl" placeholder="请输入标题（波兰语）" />
        </el-form-item>
        <el-form-item label="罗马尼亚语" style="margin-bottom: 8px;">
          <el-input v-model="active.titleRo" placeholder="请输入标题（罗马尼亚语）" />
        </el-form-item>
        <el-form-item label="匈牙利语" style="margin-bottom: 8px;">
          <el-input v-model="active.titleHu" placeholder="请输入标题（匈牙利语）" />
        </el-form-item>
        <div style="font-weight: 900;width:138px;text-align: end;margin-bottom: 10px;">详细内容</div>
        <el-form-item label="内容">
          <el-tabs v-model="activeSelect">
            <el-tab-pane label="英文" name="1">
              <div><vue-ueditor-wrap v-model="active.contentEn" :config="config" class="ueditor"/></div>
            </el-tab-pane>
            <el-tab-pane label="西班牙语" name="2">
              <div><vue-ueditor-wrap v-model="active.contentEs" :config="config" class="ueditor"/></div>
            </el-tab-pane>
            <el-tab-pane label="法语" name="4">
              <div><vue-ueditor-wrap v-model="active.contentFr" :config="config" class="ueditor"/></div>
            </el-tab-pane>
            <el-tab-pane label="德语" name="5">
              <div><vue-ueditor-wrap v-model="active.contentDe" :config="config" class="ueditor"/></div>
            </el-tab-pane>
            <el-tab-pane label="葡萄牙语" name="6">
              <div><vue-ueditor-wrap v-model="active.contentPt" :config="config" class="ueditor"/></div>
            </el-tab-pane>
            <el-tab-pane label="土耳其语" name="7">
              <div><vue-ueditor-wrap v-model="active.contentTr" :config="config" class="ueditor"/></div>
            </el-tab-pane>
            <el-tab-pane label="希腊语" name="8">
              <div><vue-ueditor-wrap v-model="active.contentGr" :config="config" class="ueditor"/></div>
            </el-tab-pane>
            <el-tab-pane label="阿拉伯语" name="9">
              <div><vue-ueditor-wrap v-model="active.contentEg" :config="config" class="ueditor"/></div>
            </el-tab-pane>
            <el-tab-pane label="意大利语" name="10">
              <div><vue-ueditor-wrap v-model="active.contentIt" :config="config" class="ueditor"/></div>
            </el-tab-pane>
            <el-tab-pane label="波斯语" name="11">
              <div><vue-ueditor-wrap v-model="active.contentIr" :config="config" class="ueditor"/></div>
            </el-tab-pane>
            <el-tab-pane label="荷兰语" name="12">
              <div><vue-ueditor-wrap v-model="active.contentNl" :config="config" class="ueditor"/></div>
            </el-tab-pane>
            <el-tab-pane label="印地语" name="13">
              <div><vue-ueditor-wrap v-model="active.contentIn" :config="config" class="ueditor"/></div>
            </el-tab-pane>
            <el-tab-pane label="乌兹别克语" name="3">
              <div><vue-ueditor-wrap v-model="active.contentUz" :config="config" class="ueditor"/></div>
            </el-tab-pane>
            <el-tab-pane label="越南语" name="14">
              <div><vue-ueditor-wrap v-model="active.contentVn" :config="config" class="ueditor"/></div>
            </el-tab-pane>
            <el-tab-pane label="印尼语" name="15">
              <div><vue-ueditor-wrap v-model="active.contentId" :config="config" class="ueditor"/></div>
            </el-tab-pane>
            <el-tab-pane label="乌尔都语" name="16">
              <div><vue-ueditor-wrap v-model="active.contentPk" :config="config" class="ueditor"/></div>
            </el-tab-pane>
            <el-tab-pane label="韩语" name="17">
              <div><vue-ueditor-wrap v-model="active.contentKr" :config="config" class="ueditor"/></div>
            </el-tab-pane>
             <el-tab-pane label="俄语" name="18">
              <div><vue-ueditor-wrap v-model="active.contentRu" :config="config" class="ueditor"/></div>
            </el-tab-pane>
            <el-tab-pane label="泰语" name="19">
              <div><vue-ueditor-wrap v-model="active.contentTh" :config="config" class="ueditor"/></div>
            </el-tab-pane>
            <el-tab-pane label="波兰语" name="20">
              <div><vue-ueditor-wrap v-model="active.contentPl" :config="config" class="ueditor"/></div>
            </el-tab-pane>
            <el-tab-pane label="罗马尼亚语" name="21">
              <div><vue-ueditor-wrap v-model="active.contentRo" :config="config" class="ueditor"/></div>
            </el-tab-pane>
            <el-tab-pane label="匈牙利语" name="22">
              <div><vue-ueditor-wrap v-model="active.contentHu" :config="config" class="ueditor"/></div>
            </el-tab-pane>
          </el-tabs>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          style="margin-right: 10px"
          @click="dialogVisible = false"
        >取消</el-button>
        <el-popconfirm title="确定添加？" @confirm="addManagement()">
          <el-button
            slot="reference"
            type="primary"
            class="edit-button"
          >保存</el-button>
        </el-popconfirm>
      </span>
    </el-dialog>

    <!-- 编辑用户弹窗 -->
    <el-dialog
      :visible.sync="edit_dialogVisible"
      width="1000px"
      title="编辑"
      :before-close="editClose"
      :close-on-click-modal="false"
    >
      <!-- 编辑用户表格 -->
      <el-form ref="editForm" :model="editForm" label-width="120px">
        <el-form-item label="排序">
          <el-input v-model="editForm.orders" placeholder="请输入序号" />
        </el-form-item>
        <el-form-item label="图片">
          <UploadImage ref="images" @upLoadImage='upLoadImage1'></UploadImage>
        </el-form-item>
        <el-form-item label="标题" prop="count">
          <el-input v-model="editForm.title" placeholder="请输入管理员账号"/>
        </el-form-item>
        <el-form-item label="详细内容">
          <div>
            <vue-ueditor-wrap v-model="editForm.content" :config="config" class="ueditor"/>
          </div>
        </el-form-item>
        <el-form-item>
          <el-popconfirm title="确定更新？" @confirm="editManagement()">
          <el-button
            slot="reference"
            type="primary"
            class="edit-button"
          >更新</el-button>
        </el-popconfirm>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination"; // 引入分页器
import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module
import UploadImage from "@/components/Upload/UploadPic"; // 引入分页器
import validEmail from "@/utils/validate"; // 引入邮箱验证方法
import md5 from "js-md5"; // 引入Md5加密

export default {
  name: "Management",
  components: { Pagination,VueUeditorWrap,UploadImage },
  data() {
    return {
      option: "", // 初始选项
      options: [], // 选择角色
      name: "", // 搜索的管理员名称
      tableData: [], // 展示的表单信息
      // 添加表单
      active: {},
      // 修改表单
      editForm: { },
      total: 0, // 总数
      pageNum: 1, // 页码值
      pageSize: 20, // 页大小
      multipleSelection: [], // 选中项s
      dialogVisible: false, // 添加弹窗
      dialog: false, // 添加弹窗
      edit_dialogVisible: false, // 编辑弹窗
      Isedit: false, // 是否是编辑弹窗
      loading: false, // 表格加
      buttongLoding: false, // 按钮加载
      activeSelect:'1',
      activeSelect1:'1',
      active:{},
      alertType:0,
      isDefaultTelegram:false,
      isDefaultWhatsapp:false,
      isDefaultMessenger:false,
      isDefaultLink:false,
      config: {
        // UEDITOR_HOME_URL: process.env.VUE_APP_BASE_UEDITORURL, // 需要令此处的URL等于对应 ueditor.config.js 中的配置。
        // UEDITOR_HOME_URL: "/normalManager/ueditor/", // 需要令此处的URL等于对应 ueditor.config.js 中的配置。本地
        UEDITOR_HOME_URL: '/ueditor/', // 需要令此处的URL等于对应 ueditor.config.js 中的配置。服务器
        autoHeightEnabled: false,
        initialFrameHeight: 450,
        initialFrameWidth: 400,
        maximumWords: 9999999,
        toolbars: [
          [
            'fullscreen',
            'source',
            '|',
            'undo',
            'redo',
            '|',
            'bold',
            'italic',
            'underline',
            'fontborder',
            'strikethrough',
            'removeformat',
            '|',
            'forecolor',
            'backcolor',
            'insertorderedlist',
            'insertunorderedlist',
            'lineheight',
            '|',
            'paragraph',
            'fontfamily',
            'fontsize',
            '|',
            'justifyleft',
            'justifycenter',
            'justifyright',
            'justifyjustify',
            '|',
            'simpleupload',
            'insertimage',
            'emotion',
            '|',
            'link',
            'unlink'
          ]
        ],
        // initialFrameWidth:3000,
        zIndex: 3000,
        // serverUrl: '',
        serverUrl: `/gw/admin/file/ueditor/upload`,
        enableAutoSave: true // 开启从草稿箱恢复功能需要手动设置固定的 editorId，否则组件会默认随机一个，如果页面刷新，下次渲染的时候 editorId 会重新随机，导致无法加载草稿箱数据
        // BaseUrl: process.env.VUE_APP_BASE_URL,
      },
      batchSet:{},
      sn:'',
      lang:'en',
      selectAlertType:'',
      uid:''
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    upLoadImage(img){
        this.active.image = img
    },
    upLoadImage1(img){
        this.editForm.image = img
    },
    // 筛选
    select() {
      this.pageNum = 1;
      this.getList();
    },
    selects(){
      if(this.multipleSelection.length > 0){
        this.dialog = true
      this.alertType = 0
      var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      this.batchSet.sns = ids.toString()
      }else{
        this.$message.error("未选择选项");
      }
    },
    message2BatchSet() {
      this.batchSet.alertType = this.alertType
      this.$api.operate
        .message2BatchSet(this.batchSet)
        .then((res) => {
          this.$message.success(res);
          this.getList();
          this.dialog = false;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.buttongLoding = false;
        });
    },
    // 获取表单信息
    getList() {
      var params = {
        pageNumber: this.pageNum,
        pageSize: this.pageSize,
        sn:this.sn,
        lang:this.lang
      };
      this.loading = true;
      this.$refs.gridTable.bodyWrapper.scrollTop = 0;
      this.$api.operate
        .xueYuanList(params)
        .then((res) => {
          this.tableData = res.records;
          this.total = res.total;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 选择或者取消行，支持全选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 关闭添加弹窗
    handleClose() {
      this.$refs.active.resetFields();
    },
    // 关闭修改弹窗
    editClose(done) {
      this.editInfo = {};
      done();
    },
    // 删除选中项
    handleDel() {
      var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      var params = {
        ids: ids.toString(),
      };
      this.$api.operate
        .xueYuanDelete(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
    },
    // 打开新增弹窗
    openAdd() {
      this.dialogVisible = true;
      this.active = {}
      this.$nextTick(()=>{
        this.$refs.image.init('')
      })
    },
    // 打开编辑弹窗
    edit(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.edit_dialogVisible = true;
      this.$nextTick(()=>{
        this.$refs.images.init(this.editForm.image)
      })
    },
    // 添加
    addManagement() {
          this.$api.operate
            .xueYuanSave(this.active)
            .then((res) => {
              this.$message.success(res);
              this.dialogVisible = false;
              this.getList();
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            })
            .finally(() => {
              this.buttongLoding = false;
            });
    },
    // 更新
    editManagement() {
      this.$api.operate
        .xueYuanUpdate(this.editForm)
        .then((res) => {
          this.$message.success(res);
          this.getList();
          this.edit_dialogVisible = false;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.buttongLoding = false;
        });
    },
    // 打开删除弹窗
    open() {
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info("你并没有选中任何选项");
      }
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.handleDel();
        })
        .catch(() => {
          
        });
    },
   
  },
};
</script>
<style lang="scss" scoped>
.role_warp {
  width: 100%;
  overflow: hidden;
  font-size: 14px;
  padding: 10px;
  box-sizing: border-box;
  .role_heard_tool {
    margin-bottom: 10px;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
}
::v-deep .edui-combox-body{
  display: flex !important;
}
::v-deep .el-input__inner{
  padding: 0 8px !important;
}
::v-deep .el-form-item--mini .el-form-item__content{
  line-height: 16px !important;
}
// ::v-deep .edui-editor-iframeholder{
//   background: #000 !important;
// } 
</style>
